var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallserver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.88 19.75h-.88a.75.75 0 0 1 0-1.5h.88a4.51 4.51 0 0 0 4.39-3.43.75.75 0 1 1 1.46.36 6 6 0 0 1 -5.85 4.57z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 9.75a.74.74 0 0 1 -.67-.42l-.21-.42a5.73 5.73 0 0 0 -10.24 0l-.21.42a.75.75 0 1 1 -1.34-.66l.21-.43a7.22 7.22 0 0 1 12.92 0l.21.43a.73.73 0 0 1 -.34 1 .76.76 0 0 1 -.33.08z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 8.25h-1a.76.76 0 0 0 -.75.75v6a.76.76 0 0 0 .75.75h1a2.75 2.75 0 0 0 2.75-2.75v-2a2.75 2.75 0 0 0 -2.75-2.75z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 8.25h-1a2.75 2.75 0 0 0 -2.75 2.75v2a2.75 2.75 0 0 0 2.75 2.75h1a.76.76 0 0 0 .75-.75v-6a.76.76 0 0 0 -.75-.75z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 8.29a4.8 4.8 0 0 0 -4.05-.92 4.75 4.75 0 0 0 -3 7.09l-.23 1.18a1.71 1.71 0 0 0 .71 1.77 1.68 1.68 0 0 0 1 .32 1.72 1.72 0 0 0 .9-.25l1.27-.76a2.73 2.73 0 0 0 .41 0 4.75 4.75 0 0 0 3-8.46z",
    fill: "#90caf9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#42a5f5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallserver);
export default __webpack_public_path__ + "static/media/callserver.358275d0e2fdd8cee74bec422119d648.svg";
export { ForwardRef as ReactComponent };